import { Link, useNavigate } from "react-router-dom";
const Header = ({logo, links, logInStatus, logInStatusChanger}) =>{
    const navigate = useNavigate();
    const logInClick = ()=>{
        logInStatusChanger(!logInStatus);
        if(logInStatus === false){
            navigate('/semester-list');
        }
    }
    return (
        <nav className="navbar navbar-dark bg-dark navbar-expand-md p-2">
            <Link to="/" className="navbar-brand">{logo}</Link>
            <button className="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbar">
                <span className="navbar-toggler-icon"></span>
            </button>
            <div className="navbar-collapse collapse" id="navbar">
                <ul className="navbar-nav">
                    {links &&
                        links.map((link, index) =>{
                            return (
                                <li key={index} className="nav-item"><Link onClick={()=>{console.log("Tick")}} to={link.to} className="nav-link">{link.text}</Link></li>
                            )
                        })
                    }
                </ul>
                <ul className="navbar-nav ms-auto">
                    <li className="nav-item">
                        <button onClick={logInClick} className="nav-link btn btn-light text-dark d-none d-md-inline">{logInStatus ? "Log Out" : "Log In"}</button>
                        <button onClick={logInClick} className="nav-link d-inline d-md-none bg-dark border border-0">{logInStatus ? "Log Out" : "Log In"}</button>
                    </li>
                </ul>
            </div>
        </nav>
    )
}

export default Header;